import ReactMarkdown from 'react-markdown'
import { getStrings, type Lang } from '../i18n'

// Renders an inline plan-card message inside the chat. The parent (App.tsx)
// owns the streaming state and updates the markdown / status props as SSE
// deltas arrive. A post-plan CTA card (see PlanCtaCard) is appended by the
// parent once streaming completes — this component itself is action-free.

interface Props {
  markdown: string
  status: 'streaming' | 'done' | 'error'
  error?: string
  onRetry: () => void
  lang?: Lang
}

export function PlanCard({ markdown, status, error, onRetry, lang = 'en' }: Props) {
  const t = getStrings(lang)
  return (
    <div className="plan-card">
      <header className="plan-card-header">
        <span className="kicker">{t.plan.kicker}</span>
        {status === 'streaming' && <span className="plan-status">{t.plan.building}</span>}
      </header>

      {markdown ? (
        <div className="plan-body">
          <ReactMarkdown>{markdown}</ReactMarkdown>
        </div>
      ) : status === 'error' ? (
        <p className="plan-error">
          {t.plan.errorPrefix}{error ?? t.plan.unknownError}.{' '}
          <button type="button" className="link-inline" onClick={onRetry}>
            {t.plan.tryAgain}
          </button>
        </p>
      ) : (
        <p className="plan-skeleton">{t.plan.skeleton}</p>
      )}
    </div>
  )
}
